export enum TestIdElementType {
  static = 'static',
  dynamic = 'dynamic',
  button = 'button',
  image = 'image',
  select = 'select',
  input = 'input',
  slider = 'slider',
  handle = 'handle',
  toggle = 'toggle',
  suffixed = 'suffixed',
  accordion = 'accordion',
}

export enum TestIdState {
  /**
   * State for a tariff tile to be highlighted.
   * Usually added when the cost calculator wants to mark a tariff to be the recommended tariff
   */
  highlighted = 'highlighted',
  selected = 'selected',
}

export interface GenerateTestIdProps {
  featureAppId: string;
  elementName: string;
  elementType: TestIdElementType;
  suffixBaseName?: string;
  state?: TestIdState;
}

export const generateTestId = ({
  featureAppId,
  elementName,
  elementType,
  suffixBaseName,
  state,
}: GenerateTestIdProps): string => {
  const elementNameProcessed = elementName.replace(/_/g, '-');
  const elementTypeProcessed = suffixBaseName
    ? `container-${suffixBaseName}`
    : elementType;
  const stateProcessed = state ? `--${state}` : '';

  return `${featureAppId}--${elementNameProcessed}--${elementTypeProcessed}${stateProcessed}`;
};
